import { ADD_TEILNAHME_CHANGE_EFN, 
	ADD_TEILNAHME_TOGGLE_PUNKTE_BASIS, 
	ADD_TEILNAHME_TOGGLE_PUNKTE_LERNERFOLG,
	ADD_TEILNAHME_REF_PUNKTE_CHANGE, 
	ADD_TEILNAHME_EFN_QRCODE_SCANNED,
	ADD_TEILNAHME_QR_READER_TOGGLE_MULTISCAN_MODE,
	ADD_TEILNAHME_REF_PUNKTE_DECREASE, 
	ADD_TEILNAHME_REF_PUNKTE_INCREASE, ADD_TEILNAHME_HINZUGUEGEN, PUNKTEMELDUNG_REMOVE_TEILNEHMER,
	PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_BASIS, PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_LERNERFOLG,
	PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_CHANGE, PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_DECREASE, 
	PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_INCREASE, ADD_TEILNAHME_CHANGE_TEILNAHMEDATUM, 
	PUNKTEMELDUNG_TEILNEHMER_CHANGE_TEILNAHMEDATUM,
	ADD_TEILNAHME_SANITIZE_EFNS, ADD_TEILNAHME_REMOVE_UNGUELTIGE_EFNS,
	PUNKTEMELDUNG_BESCHRIFTUNG_SET, PUNKTEMELDUNG_BESCHRIFTUNG_REMOVE, PUNKTEMELDUNG_BESCHRIFTUNGEN_CLEAR,
	PUNKTEMELDUNG_BESCHRIFTUNG_AUS_SCAN, PUNKTEMELDUNG_BESCHRIFTUNG_SCAN_VERWERFEN
 } from "./actions";
import { fobiCore } from "../../FobiCore";
import { istGleicheBeschriftung, istGleicherNameStreng } from "./efnBarcodeContentRecogniser";
import { parseListe, kanonischeBeschriftungen, uebernehmbareEFNs, restText, istEinzelmodus,
	entferneFremdinhaltJeZeile, nurEFNsJeZeile } from "./listenEingabe";
import { MAX_ALLOWED_REF_PUNKTE } from "../../EivngCore"
import { FETCH_VERANSTALTUNG_REQUEST_SUCCESS, 
	DELETE_VERANSTALTUNG, 
	FETCH_PUNKTEMELDUNGEN_REQUEST_SUCCESS } from "../veranstaltungen/actions";
import moment from "moment";
import { TEILNEHMER_MELDEN_PUSH_COMPLETED, REMOVE_ALL_SEIZED_TEILNEHMER,
	TEILNEHMER_MELDEN_REQUESTED, TEILNEHMER_MELDEN_COMPLETED,
	TEILNEHMER_MELDEN_FAILED, istGemeldeterStand } from "./teilnehmermeldenActionCreator";

const teilnahmeMeldungenOfVNRReducer = (stateMeldungenOfVNR = {}, action) => {
	switch(action.type){
		case FETCH_PUNKTEMELDUNGEN_REQUEST_SUCCESS:
			const stateAggregiert = {...stateMeldungenOfVNR}
			action.punktemeldungen.map( (punkteMeldung) => {
				stateAggregiert[punkteMeldung.efn] = punkteMeldung
				return punkteMeldung
			})
			return stateAggregiert
		default:	
	}
	return stateMeldungenOfVNR
}
/** 
 * state sind meldungen als { vnr : { efn : efnMeldung }}
 */ 
export const teilnahmeMeldungenReducer = (state = {}, action) => {
	const vnr = action.vnr
	switch(action.type){
		case DELETE_VERANSTALTUNG:
			const data = {...state}
			delete data[vnr]
			return data;
		default: 
	}
	if(vnr === undefined) return state
	const stateMeldungenOfVNR = state[vnr]
	return {...state, [vnr]: teilnahmeMeldungenOfVNRReducer(stateMeldungenOfVNR, action)}
}

export const initialStateAddTeilnahme = {
	efn: "",
	punkte_basis_flag : true,
	punkte_lernerfolg_flag : false,
	punkte_referent : 0,
	teilnahmedatum : null
}

/**
 * wenn das eine laufende Veranstaltung, dann macht es Sinn das heutige Datum vorzuschlagen, sonst wird Anfang der Veranstaltung vorgeschlagen
 * @param {*} veranstaltung 
 * @returns 
 */
const getInitialTeilnahmedatum = (veranstaltung) => {
	const now = moment();
	const beginn = moment(veranstaltung.beginn);
	const ende = moment(veranstaltung.ende);
	if(now.isSameOrAfter(beginn) && now.isSameOrBefore(ende)){
		return now.endOf("day").valueOf();
	}
	const teilnahmedatum = moment(veranstaltung.beginn).endOf("day").valueOf();
	return teilnahmedatum;
}

export const addTeilnahmeReducer = (state = {}, action) => {
	switch(action.type){
		case FETCH_VERANSTALTUNG_REQUEST_SUCCESS:
			const teilnahmedatum = getInitialTeilnahmedatum(action.veranstaltung);
			return {...state, [action.veranstaltung.vnr]: {...initialStateAddTeilnahme, teilnahmedatum}}
		case DELETE_VERANSTALTUNG:
			const data = {...state}
			delete data[action.vnr]
			return data	
		default:

	}
	if(action.vnr === undefined) return state
	const teilnahmeOfVNR = state[action.vnr]
	if(teilnahmeOfVNR !== undefined) return {...state, [action.vnr]: addTeilnahmeOfVNRReducer(teilnahmeOfVNR, action)}
	return state
}
export const qrReaderReducer = (state = {}, action) => {
	switch(action.type){
		case ADD_TEILNAHME_QR_READER_TOGGLE_MULTISCAN_MODE:
			return {...state, multiscanMode: !state.multiscanMode}
		default: return state;
	}
}

export const addTeilnahmeOfVNRReducer = (state = initialStateAddTeilnahme, action) => {
	switch(action.type){
		case ADD_TEILNAHME_HINZUGUEGEN:
			// Uebernommen wird, was geht - der Rest bleibt stehen. Das Feld ist danach die
			// Restliste, das leere Feld die Quittung. Eine vertippte EFN unter vierzig guten
			// sperrt damit nicht mehr alles, verschwindet aber auch nicht still.
			return {...state, efn: restText(parseListe(action.eingabe).zeilen),
				punkte_referent : 0
			}
		case PUNKTEMELDUNG_BESCHRIFTUNGEN_CLEAR:
			// Der Knopf sagt zu, "alle hinterlegten Namen und Notizen" zu entfernen. Bis hierher galt das nur fuer den beschriftungen-Slice - Namen in einer
			// stehengebliebenen Zeile ueberlebten und standen weiter im localStorage. Die
			// Nummern bleiben, die Namen gehen.
			return {...state, efn: entferneFremdinhaltJeZeile(state.efn)}
		case PUNKTEMELDUNG_REMOVE_TEILNEHMER:
			// Die entfernte EFN landet im Eingabefeld, damit ein versehentliches Entfernen
			// mit einem Klick auf "Hinzufuegen" rueckgaengig gemacht werden kann - aber nur,
			// wenn dort nichts steht. Die urspruengliche Bedingung !isEFN() traf zu, sobald
			// das Feld nicht genau eine gueltige EFN enthielt; bei einer eingefuegten Liste
			// war das immer der Fall und die Eingabe ging verloren.
			if(!state.efn.trim()) return {...state, efn: action.efn}
			return state;
		case REMOVE_ALL_SEIZED_TEILNEHMER:
			// if(!fobiCore.isEFN(state.efn) && action.efns ) return {...state, efn: action.efns}
			if( action.efns ) return {...state, efn: action.efns}
			return state;
		case ADD_TEILNAHME_CHANGE_EFN:
			return {...state, efn: action.payload}
		// Zweistufig: "bereinigen" raeumt den Beifang aus einer eingefuegten Liste weg
		// (Namen, Datumsangaben, PLZ) und laesst stehen, was wie eine EFN aussieht.
		// Erst danach bietet "ungueltige entfernen" an, die fraglichen Nummern zu
		// verwerfen - eine bewusste Handlung, weil damit ein Teilnehmer aus der Meldung
		// faellt und der Veranstalter die Nummer nicht korrigieren kann.
		case ADD_TEILNAHME_SANITIZE_EFNS:{
			return {...state, efn: entferneFremdinhaltJeZeile(state.efn)};
		}
		case ADD_TEILNAHME_REMOVE_UNGUELTIGE_EFNS:{
			return {...state, efn: nurEFNsJeZeile(state.efn)};
		}
		case ADD_TEILNAHME_REF_PUNKTE_INCREASE:
					return {...state, punkte_referent: state.punkte_referent < MAX_ALLOWED_REF_PUNKTE?++state.punkte_referent:MAX_ALLOWED_REF_PUNKTE}
		case ADD_TEILNAHME_REF_PUNKTE_DECREASE:
				return {...state, punkte_referent: state.punkte_referent > 0?--state.punkte_referent:0}
		case ADD_TEILNAHME_REF_PUNKTE_CHANGE:
				return {...state, punkte_referent: action.payload}
		case ADD_TEILNAHME_CHANGE_TEILNAHMEDATUM:
				return {...state, teilnahmedatum: action.teilnahmedatum}					
		case ADD_TEILNAHME_TOGGLE_PUNKTE_BASIS:
				return {...state, punkte_basis_flag: !state.punkte_basis_flag}
		case ADD_TEILNAHME_TOGGLE_PUNKTE_LERNERFOLG:
				return {...state, punkte_lernerfolg_flag: !state.punkte_lernerfolg_flag}		
		default: return state;
	}
	
}
/** 
 * state sind erfassteTeilnahmen, bzw. Teilnehmer als { vnr : { efn : efnMeldung }}
 */ 
export const erfassteTeilnahmenReducer = (state = {}, action) => {
	switch(action.type){
		case DELETE_VERANSTALTUNG:
			const teilnahmenData = {...state}
			delete teilnahmenData[action.vnr]
			return teilnahmenData;
		case REMOVE_ALL_SEIZED_TEILNEHMER:
			{
				return {...state, [action.vnr] : {}}
			}
		case TEILNEHMER_MELDEN_PUSH_COMPLETED:
		{
				// Gestrichen wird nur, was auch gemeldet wurde. Wer eine Zeile waehrend ihres
				// eigenen Requests bearbeitet, verlor sie sonst: geloescht wurde allein anhand
				// der EFN, und die Aenderung war weg, ohne je gemeldet worden zu sein. Weicht
				// der Stand ab, bleibt die Zeile stehen und geht beim naechsten Melden mit -
				// die API ist auf EFN+VNR idempotent, der neuere Stand gewinnt.
				const vorhanden = (state[action.vnr] || {})[action.efn]
				if(action.gemeldet && !istGemeldeterStand(vorhanden, action.gemeldet)) return state;
				const teilnahmen = {...state[action.vnr] }
				delete teilnahmen[action.efn]; 
				return {...state, [action.vnr] : teilnahmen}
		}
		case PUNKTEMELDUNG_REMOVE_TEILNEHMER:
				const teilnahmen = {...state[action.vnr] }
				delete teilnahmen[action.efn]; 
			return {...state, [action.vnr] : teilnahmen}
		
		case ADD_TEILNAHME_EFN_QRCODE_SCANNED:{
			const intendedEFN = action.payload;
			const teilnahmeState = {...initialStateAddTeilnahme };
			if(action.addTeilnahmeState){
				teilnahmeState.teilnahmedatum = action.addTeilnahmeState.teilnahmedatum;
				teilnahmeState.punkte_basis_flag = action.addTeilnahmeState.punkte_basis_flag;
				teilnahmeState.punkte_lernerfolg_flag = action.addTeilnahmeState.punkte_lernerfolg_flag;
				teilnahmeState.punkte_referent = action.addTeilnahmeState.punkte_referent;

			}
			
			const teilnahmen = { ...state[action.vnr] };
			if(!fobiCore.isEFN(intendedEFN)) return state;
			const efn = intendedEFN;
			// addedTimestamp auch beim Scannen setzen - sonst greift die Sortierung
			// "neueste oben" in ErfassteTeilnehmer.jsx ausgerechnet fuer gescannte
			// Teilnahmen nicht und sie landen unten in einer langen Liste.
			teilnahmen[efn] = {...teilnahmeState, efn, addedTimestamp: Date.now()};
			return {...state, [action.vnr] : teilnahmen };
		}
		
		case ADD_TEILNAHME_HINZUGUEGEN:{
			if(!fobiCore.isVNR(action.vnr)) return state;
			const efns = uebernehmbareEFNs(parseListe(action.eingabe).zeilen);
			if(efns.length === 0) return state;
			// Bei mehreren EFNs keine Referenten- oder Lernerfolgspunkte automatisch schreiben.
			// Gezaehlt werden EFNs, nicht Ziffernbloecke: bei "<EFN> Praxis 2" haette
			// containsMultipleEFNs true geliefert und dem Anwender die gerade gesetzten
			// Lernerfolg- und Referentenpunkte wieder weggenommen.
			const vorlage = efns.length > 1
				? {...action.teilnahmeVorlage, punkte_lernerfolg_flag: false, punkte_referent: 0}
				: action.teilnahmeVorlage;
			// Nur im Einzelmodus (eine Zeile, eine EFN) wird eine vorhandene Teilnahme
			// aktualisiert - das ist der Korrekturweg an der Tuer. Bei einer eingefuegten Liste
			// blieben sonst Punkte, Datum und Zeitstempel von vierzig Teilnahmen auf der
			// Strecke. Der Scanner haelt es genauso (QRCodeScannerDialog: !erfassteT[efn]).
			const einzeln = istEinzelmodus(action.eingabe);
			const teilnahmen = { ...state[action.vnr] };
			efns.forEach(efn => {
				if(!einzeln && teilnahmen[efn]) return;
				teilnahmen[efn] = {...vorlage, efn, addedTimestamp: action.addedTimestamp};
			});
			return {...state, [action.vnr] : teilnahmen }
		}
		case PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_CHANGE:
			const pmrpcTeilnahme = {...state[action.vnr][action.efn], punkte_referent: action.refPunkte}
			const pmrpcTeilnahmen = {...state[action.vnr], [action.efn] : pmrpcTeilnahme}
			return  {...state, [action.vnr] : pmrpcTeilnahmen }
		case PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_INCREASE:
			let pmrpipunkteReferent = state[action.vnr][action.efn].punkte_referent;
			const pmrpiTeilnahme = {...state[action.vnr][action.efn], punkte_referent: pmrpipunkteReferent < MAX_ALLOWED_REF_PUNKTE?
				++pmrpipunkteReferent:pmrpipunkteReferent }
			const pmrpiTeilnahmen = {...state[action.vnr], [action.efn] : pmrpiTeilnahme}
			return  {...state, [action.vnr] : pmrpiTeilnahmen }
		case PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_DECREASE:
			let pmrpdpunkteReferent = state[action.vnr][action.efn].punkte_referent;
			const pmrpdTeilnahme = {...state[action.vnr][action.efn], punkte_referent: pmrpdpunkteReferent > 0?
				--pmrpdpunkteReferent:pmrpdpunkteReferent }
			const pmrpdTeilnahmen = {...state[action.vnr], [action.efn] : pmrpdTeilnahme}
			return  {...state, [action.vnr] : pmrpdTeilnahmen }	
		case PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_BASIS:
			const tbTeilnahme = {...state[action.vnr][action.efn], punkte_basis_flag: !state[action.vnr][action.efn].punkte_basis_flag}
			const teilnahmenTB = {...state[action.vnr], [action.efn] : tbTeilnahme}
			return  {...state, [action.vnr] : teilnahmenTB }
		case PUNKTEMELDUNG_TEILNEHMER_CHANGE_TEILNAHMEDATUM:
				const tbchdTeilnahme = {...state[action.vnr][action.efn], teilnahmedatum: action.teilnahmedatum}
				const teilnahmenTBCHD = {...state[action.vnr], [action.efn] : tbchdTeilnahme}
				return  {...state, [action.vnr] : teilnahmenTBCHD }
			
		case PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_LERNERFOLG:
			const tlTeilnahme = {...state[action.vnr][action.efn], punkte_lernerfolg_flag: !state[action.vnr][action.efn].punkte_lernerfolg_flag}
			const teilnahmenTL = {...state[action.vnr], [action.efn] : tlTeilnahme}
			return  {...state, [action.vnr] : teilnahmenTL }
		
		default: return state;
	}
}

/**
 * Beschriftungen zu EFNs als { vnr : { efn : { text } } }.
 *
 * Bewusst ein eigener Slice und kein Feld am Teilnahme-Objekt: die Teilnahme geht so, wie
 * sie im Store liegt, an die Veranstalter-API (siehe peekTeilnahmeToSend) - ein Name waere
 * dort unbemerkt mit auf der Leitung. Ausserdem wird die Teilnahme nach dem Melden aus
 * erfassteTeilnahmen entfernt und das Protokoll kommt vom Server ohne Namen; die
 * Beschriftung muss diesen Uebergang ueberleben.
 *
 * Geloescht wird deshalb nur an zwei Stellen: mit der Veranstaltung und auf ausdruecklichen
 * Wunsch. Weder das Melden noch das Entfernen einer erfassten Teilnahme raeumt sie weg.
 */
export const beschriftungenReducer = (state = {}, action) => {
	switch(action.type){
		case DELETE_VERANSTALTUNG:
		{
			const daten = {...state};
			delete daten[action.vnr];
			return daten;
		}
		case PUNKTEMELDUNG_BESCHRIFTUNGEN_CLEAR:
		{
			const daten = {...state};
			delete daten[action.vnr];
			return daten;
		}
		case PUNKTEMELDUNG_BESCHRIFTUNG_SET:
		{
			const text = (action.beschriftung.text || "").trim();
			if(!text) return beschriftungenReducer(state, {...action, type: PUNKTEMELDUNG_BESCHRIFTUNG_REMOVE});
			// Eine Eingabe von Hand ist die Entscheidung: ein gemerkter abweichender Scan
			// hat sich damit erledigt.
			const beschriftungenOfVNR = {...state[action.vnr], [action.efn]: { text }};
			return {...state, [action.vnr]: beschriftungenOfVNR};
		}
		case PUNKTEMELDUNG_BESCHRIFTUNG_REMOVE:
		{
			if(!state[action.vnr]) return state;
			const beschriftungenOfVNR = {...state[action.vnr]};
			delete beschriftungenOfVNR[action.efn];
			return {...state, [action.vnr]: beschriftungenOfVNR};
		}
		case PUNKTEMELDUNG_BESCHRIFTUNG_SCAN_VERWERFEN:
		{
			const vorhanden = state[action.vnr] && state[action.vnr][action.efn];
			if(!vorhanden || !vorhanden.abweichenderScan) return state;
			const { abweichenderScan, ...ohneWiderspruch } = vorhanden;
			return {...state, [action.vnr]: {...state[action.vnr], [action.efn]: ohneWiderspruch}};
		}
		case PUNKTEMELDUNG_BESCHRIFTUNG_AUS_SCAN:
			return uebernehmeBeschriftungAusScan(state, action.vnr, action.efn, action.beschriftung);
		case ADD_TEILNAHME_EFN_QRCODE_SCANNED:
		{
			const efn = action.payload;
			if(!fobiCore.isEFN(efn)) return state;
			return uebernehmeBeschriftungAusScan(state, action.vnr, efn, action.beschriftung);
		}
		case ADD_TEILNAHME_HINZUGUEGEN:
		{
			// Je EFN eine Beschriftung, gebildet aus allen Zeilen, die sie nennen - und dann der
			// Reihe nach durch dieselbe Konfliktbehandlung wie ein Scan. Der zurueckgegebene
			// State muss dabei weitergereicht werden (reduce, nicht forEach), sonst ueberlebte
			// nur der letzte Eintrag.
			// Die erste Beschriftung je EFN geht den gewohnten Weg (sie kann einer *bereits
			// gespeicherten* mild widersprechen). Jede weitere ist per Konstruktion ein streng
			// festgestellter Widerspruch und wird als solcher durchgereicht.
			const schonGesetzt = new Set();
			return kanonischeBeschriftungen(parseListe(action.eingabe).zeilen).reduce(
				(zwischenstand, eintrag) => {
					const weitere = schonGesetzt.has(eintrag.efn);
					schonGesetzt.add(eintrag.efn);
					return uebernehmeBeschriftungAusScan(zwischenstand, action.vnr, eintrag.efn, eintrag, weitere);
				},
				state);
		}
		default: return state;
	}
}

/**
 * Beschriftung aus einem Barcode. Drei Faelle, und keiner davon verliert etwas:
 *
 * 1. Noch nichts hinterlegt -> uebernehmen. So laesst sich eine bereits erfasste Liste im
 *    Multiscan-Modus nachtraeglich mit Namen anreichern.
 * 2. Es steht schon derselbe Name da (auch abgekuerzt oder ohne Titel, siehe
 *    istGleicheBeschriftung) -> stehen lassen.
 * 3. Es steht ein *anderer* Name da -> der vorhandene bleibt, der gescannte wird als
 *    `abweichenderScan` gemerkt. Ein Scan darf eine von Hand gesetzte Notiz nicht
 *    ueberschreiben; ihn wegzuwerfen waere aber genauso falsch, denn zwei Namen zu einer EFN
 *    sind der einzige Hinweis darauf, dass ein Ausweis die falsche EFN traegt - und dann
 *    wuerden Punkte auf den falschen Arzt gebucht. Aufgeloest wird das spaeter in der Zeile,
 *    nicht am Einlass.
 */
const uebernehmeBeschriftungAusScan = (state, vnr, efn, beschriftung, alsWiderspruch = false) => {
	const text = (beschriftung && beschriftung.text ? beschriftung.text : "").trim();
	if(!text) return state;
	const vorhanden = state[vnr] && state[vnr][efn];
	if(!vorhanden || !vorhanden.text){
		return {...state, [vnr]: {...state[vnr], [efn]: { text }}};
	}
	// `alsWiderspruch` kommt aus dem Listenpfad und schaltet auf den **strengen** Vergleich um:
	// dort wurde bereits entschieden, dass "Max" und "Maximilian" zwei Menschen sind, und der
	// milde Vergleich wuerde sie wieder zusammenwerfen.
	//
	// Blind zu widersprechen waere aber falsch. Steht schon "Erika Musterfrau" da und die Liste
	// nennt Max *und* Erika, dann setzt die Max-Zeile den Widerspruch - und die Erika-Zeile darf
	// ihn nicht wieder ueberschreiben, nur weil sie die zweite Gruppe ist. Sie ist mit dem
	// Vorhandenen identisch und aendert nichts.
	const istGleich = alsWiderspruch
		? istGleicherNameStreng(vorhanden.text, text)
		: istGleicheBeschriftung(vorhanden.text, text);
	if(istGleich) return state;
	return {...state, [vnr]: {...state[vnr], [efn]: {...vorhanden, abweichenderScan: { text }}}};
}

/** Widerspricht dieser Scan dem, was schon dasteht? Fuer die Meldung im Scan-Dialog. */
export const istAbweichenderScan = (vorhanden, beschriftung) => {
	if(!vorhanden || !vorhanden.text) return false;
	const text = (beschriftung && beschriftung.text ? beschriftung.text : "").trim();
	if(!text) return false;
	return !istGleicheBeschriftung(vorhanden.text, text);
}

/**
 * Der Merker fuer einen abgebrochenen Meldeversuch - je VNR hoechstens einer.
 *
 * Die Liste der erfassten Teilnahmen ist die Warteschlange: was nicht bestaetigt gemeldet
 * wurde, bleibt stehen. Das ist richtig, aber stumm - bei einem Netzabbruch hoert das Melden
 * einfach auf, und niemand sagt dem Anwender, dass er noch einmal druecken soll. Hier steht
 * deshalb der eine Satz, den es dafuer braucht: letzter Versuch abgebrochen, mit Statuscode
 * und der EFN, an der es haengengeblieben ist.
 *
 * TEILNEHMER_MELDEN_COMPLETED loescht den Merker bewusst **nicht**: die Action wird auch nach
 * einem Abbruch geschickt, sie heisst "Schleife beendet", nicht "alles gemeldet". Sie beendet
 * nur `laeuft`. Geloescht wird beim naechsten Versuch - und angezeigt wird ohnehin nur, solange
 * noch etwas dasteht.
 *
 * `laeuft` sperrt waehrend der Uebertragung den Meldeknopf. Ein zweiter Druck waere wegen der
 * Idempotenz der API fachlich harmlos, schickte aber jede Teilnahme ein zweites Mal ueber die
 * Leitung. Der Zustand ueberlebt bewusst keinen Reload - `saveState` streicht ihn, wie es
 * `fetchCounter` zurueckstellt: ein Tab, der mitten in der Schleife geschlossen wird, darf den
 * Knopf nicht dauerhaft tot zurueckgeben.
 */
export const meldeversuchReducer = (state = {}, action) => {
	switch(action.type){
		case TEILNEHMER_MELDEN_REQUESTED:
			return {...state, [action.vnr]: { laeuft: true }};
		case DELETE_VERANSTALTUNG:
		case REMOVE_ALL_SEIZED_TEILNEHMER:
			{
				if(state[action.vnr] === undefined) return state;
				const data = {...state};
				delete data[action.vnr];
				return data;
			}
		case TEILNEHMER_MELDEN_FAILED:
			// `abgebrochen` ist ein eigenes Flag und nicht aus `status` abgeleitet: der haeufigste
			// Abbruch ueberhaupt - kein Netz - hat gar keinen Statuscode. Wer hier auf
			// "status === undefined" prueft, haelt genau diesen Fall fuer einen sauberen Durchlauf.
			return {...state, [action.vnr]: { ...state[action.vnr], abgebrochen: true,
				status: action.payload, efn: action.efn }};
		case TEILNEHMER_MELDEN_COMPLETED:
			{
				// Ohne Abbruch bleibt nichts zu merken uebrig - dann faellt der Eintrag ganz weg.
				const vorher = state[action.vnr];
				if(vorher === undefined) return state;
				if(!vorher.abgebrochen){
					const data = {...state};
					delete data[action.vnr];
					return data;
				}
				return {...state, [action.vnr]: {...vorher, laeuft: false}};
			}
		default:
			return state;
	}
}
